import React from 'react';
import gallery1 from '../assets/gallery-1.png';
import gallery2 from '../assets/gallery-2.png';

const Gallery = () => {
  return (
    <section id="gallery" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">第1回コンテストより</h2>
          <div className="w-20 h-1 bg-blue-900 mx-auto"></div>
          <p className="mt-4 text-gray-600">昨年度開催された第1回大会の様子をご紹介します</p>
        </div>

        <div className="space-y-12 max-w-5xl mx-auto">
          <div className="bg-white p-4 md:p-8 rounded-xl shadow-lg border border-gray-100">
            <img 
              src={gallery1} 
              alt="第1回コンテストの様子 1" 
              className="w-full h-auto rounded shadow-sm"
            />
          </div>
          <div className="bg-white p-4 md:p-8 rounded-xl shadow-lg border border-gray-100">
            <img 
              src={gallery2} 
              alt="第1回コンテストの様子 2" 
              className="w-full h-auto rounded shadow-sm"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
